// WarningModal.tsx
import React, { forwardRef, useState } from "react";
import { ButtonGroup, Button, Modal, ModalBody } from "reactstrap";

type Message = { code: string; description: string };

export interface WarningModalProps {
  item?: any;
  msg: string;
  messages?: Message[];
  action: (value?: any) => void;
  dismissLabel?: string;
  yesLabel?: string;
  hideYesButton?: boolean;
  dismissAction?: boolean;
  className?: string;
}

const WarningModal = forwardRef<HTMLElement, WarningModalProps>(
  (
    {
      item,
      msg,
      messages = [],
      action,
      dismissLabel = "No",
      yesLabel = "Yes",
      hideYesButton = false,
      dismissAction = false,
      className = "warning",
    },
    ref,
  ) => {
    const [modal, setModal] = useState(true);

    const toggle = (value: any = false) => {
      setModal(!modal);
      action(value);
    };

    const refineMessages = () => {
      const codes = messages.map((o) => o.code);
      const duplicateCount = codes.reduce<Record<string, number>>((a, c) => {
        a[c] = (a[c] || 0) + 1;
        return a;
      }, {});
      const deduplicatedMessages = messages.filter(
        ({ code }, index) => !codes.includes(code, index + 1),
      );
      return deduplicatedMessages.map((m) => ({
        ...m,
        count: duplicateCount[m.code] ?? 1,
      }));
    };

    return (
      <div>
        <Modal
          isOpen={modal}
          toggle={toggle}
          backdrop="static"
          keyboard={false}
          container={(ref as any) ?? "body"}
        >
          <div className={`bg-${className} text-light`}>
            <ModalBody className="d-flex justify-content-between">
              <div>
                <span>{msg}</span>
                {!!messages?.length && (
                  <div className="mt-2">
                    <ul>
                      {refineMessages().map((m) => (
                        <li key={m.code}>
                          {m.description}
                          {m.count > 1 ? ` x ${m.count}` : ""}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <ButtonGroup style={{ marginLeft: 10, height: 35 }}>
                {!hideYesButton && (
                  <Button
                    outline
                    color="light"
                    size="sm"
                    onClick={() => toggle(item)}
                    className="text-nowrap"
                  >
                    {yesLabel}
                  </Button>
                )}
                <Button
                  outline
                  color="light"
                  size="sm"
                  onClick={() => toggle(dismissAction && item)}
                >
                  {dismissLabel}
                </Button>
              </ButtonGroup>
            </ModalBody>
          </div>
        </Modal>
      </div>
    );
  },
);

export default WarningModal;
